import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

import { algoliaProxyRecordAccessorGetDeeplink } from '../../../algolia'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemPrescriptionProductLinkWithIcon: FC =
  () => {
    const {
      algoliaRecord,
      onProductClick,
      query = '',
    } = useProductSearchResultItemContext()

    const { __position: position, __queryID: queryID = '' } = algoliaRecord

    return (
      <Button<'a'>
        className="z-10 text-dark-brand"
        data-qa-id="online-doctor-service"
        endIcon={<IconArrowRight />}
        href={algoliaProxyRecordAccessorGetDeeplink({
          params: {
            eventName: 'click on product list item',
            position,
            query,
            queryID,
          },
          record: algoliaRecord,
        })}
        onClick={onProductClick}
        size="medium"
        variant="text"
      >
        <FormattedMessage id="general.link.label.recipe" />
      </Button>
    )
  }
